import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface NoIdentityLayoutProps {
    footerContent?: React.FunctionComponent | React.ReactElement | string | false
}

const NoIdentityLayout: React.FunctionComponent<NoIdentityLayoutProps> = (props) => {
    const { children } = props
    return (
        <div>
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {children}
            {props.footerContent}
        </div>
    );
}

export default NoIdentityLayout; 